import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyEinLettersPage, parseAgencyEinSearch } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

/** Every agency member may open it (the parent layout gates non-agency users; the API scopes letters per member). */
export const Route = createFileRoute('/_auth/agency/ein')({
  validateSearch: parseAgencyEinSearch,
  component: AgencyEinRoute,
});

function AgencyEinRoute() {
  const { q, status } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('EIN letters')}</title>
      </Helmet>
      <AgencyEinLettersPage
        q={q}
        status={status}
        // A search or filter change replaces the history entry, so Back leaves the page.
        onSearchChange={(next) => void navigate({ search: next, replace: true })}
      />
    </>
  );
}
